import { render, staticRenderFns } from "./classical-class-observation-detail.vue?vue&type=template&id=36248505"
import script from "./classical-class-observation-detail.vue?vue&type=script&lang=js"
export * from "./classical-class-observation-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports